import React, { useEffect, useState } from "react";
import Map, { Marker, Popup } from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import { Tabs } from "antd";
import { BASE_URL } from "../routes/config";
import axios from "axios";

const MAPBOX_TOKEN = "pk.eyJ1IjoidXRzYWIyMDIwIiwiYSI6ImNtMTdvajcyYTB4cXoya3I0YWp3bmE2aGcifQ.ed_uttIpJVLQhDWfj7cryw"; // Replace with your Mapbox token

// const branchLocations = [
//   { id: 1, name: "<strong>Branch 1 </strong><br/>Southend Conclave, 3rd Floor, 1582 Rajdanga Main Road, Kolkata - 700 107", coordinates: [88.3629, 22.5744],
//     branch_name: "Siliguri",
//     addr: "SethSrilalMarket P.O Siliguri, Dist. Darjeeling",
//     location: "26.715542,88.423548"
//    },
//   { id: 2, name: "<strong>Branch 2 </strong><br/>Southend Conclave, 3rd Floor, 1582 Rajdanga Main Road, Kolkata - 700 107", coordinates: [87.1629, 21.3744],
//     branch_name: "Kolkata",
//     addr: "SethSrilalMarket P.O Siliguri, Dist. Darjeeling",
//     location: "26.523945,88.724679"
//    }
// ];

const godownLocations = [
  {
    w_name: "BENFED BANJETIA 1",
    w_addrs: "3 No. Banjethia, Berhampore, Murshidabad, 742103,",
    location: "24.106548,88.2810093",
    location_link: "https://www.google.com/maps/place/3+No,+3no,+Raninagar,+Banjetia,+Cossimbazar,+Berhampore,+West+Bengal+742102/@24.106548,88.2810093,17z/data=!3m1!4b1!4m6!3m5!1s0x39f97da16eea9531:0xee319fd56d7f4af8!8m2!3d24.106548!4d88.2810093!16s%2Fg%2F11g0773pph?entry=ttu&g_ep=EgoyMDI1MDEyNy4wIKXMDSoASAFQAw%3D%3D"
  },
  {
    w_name: "BENFED BANJETIA 2",
    w_addrs: "3 No. Banjethia, Berhampore, Murshidabad, 742103",
    location: "24.106548,85.2810093",
    location_link: "https://www.google.com/maps/place/3+No,+3no,+Raninagar,+Banjetia,+Cossimbazar,+Berhampore,+West+Bengal+742102/@24.106548,88.2810093,17z/data=!3m1!4b1!4m6!3m5!1s0x39f97da16eea9531:0xee319fd56d7f4af8!8m2!3d24.106548!4d88.2810093!16s%2Fg%2F11g0773pph?entry=ttu&g_ep=EgoyMDI1MDEyNy4wIKXMDSoASAFQAw%3D%3D"
  },
  {
    w_name: "BENFED MECHOGRAM GODOWN-1(NCDC)",
    w_addrs: "UTTAR MECHOGRAM, BLOCK-PANSKURA-I, P.S - PANSKURA, DIST-PURBA MEDINIPUR, PIN-721139",
    location: "22.4207587,86.7197253",
    location_link: ""
  },
  {
    w_name: "BENFED MECHOGRAM GODOWN-2(RIDF)",
    w_addrs: "UTTAR MECHOGRAM, BLOCK- PANSKURA-I, P.S- PANSKURA, DIST- PURBA MEDINIPUR, PIN-721139",
    location: "24.9648655, 88.1256994",
    location_link: null
  }
];







function TabContentHome_NetworkMap() {
  const [selectedLocation, setSelectedLocation] = useState(null); // For popup handling
  const [activeTab, setActiveTab] = useState("branch"); // Track active tab
  const [loading, setLoading] = useState(true);
  const [branchLocations_, setBranchLocations] = useState([]);
  const [godownLocations_, setGodownLocations] = useState([]);

  const [animationClass, setAnimationClass] = useState("");

  const locations_Map = activeTab === "branch" ? branchLocations_ : godownLocations_;

  const handleMarkerClick = (location) => {
    setSelectedLocation(location);
    setAnimationClass("popup-animation-enter");
  };

  const handleTabChange = (key) => {
    setActiveTab(key);
    setSelectedLocation(null); // Clear selected location when tab changes
  };


  const fetchMapdata_branch = async ()=>{
      

    axios.post(`${BASE_URL}/wapi/getbranchdtl`,
      {
        auth_key:"xxxxx",
      }
      ,
      {
          headers: {
            auth_key: "c299cf0ae55ac8a2e3932b65fe5f08538962c5114d5680db8193eb2d3116",
          },
      }
      
      ).then(res => {
        // console.log('rruuuuuuuuurrrr', res);
        if(res.status == '200'){
          
          if(res.data.suc > 0){
            setBranchLocations(res?.data?.msg);
            setLoading(false)
  
          } else {
            setBranchLocations([])
            // pageDataCheck = res.data.status;
          }
    
          }
  
      }) 
  
   }

   const fetchMapdata_wearhouse = async ()=>{

    axios.post(`${BASE_URL}/wapi/getwearhousedtl`,
      {
        auth_key:"xxxxx",
      }
      ,
      {
          headers: {
            auth_key: "c299cf0ae55ac8a2e3932b65fe5f08538962c5114d5680db8193eb2d3116",
          },
      }
      
      ).then(res => {
        // console.log('rruuuuuuuuurrrr', res);
        
        console.log('jjjjjjjjjjjjjjjjjjjjjjjjj', 'hhhhhhhhhh');

        if(res.status == '200'){
          if(res.data.suc > 0){
            
            setGodownLocations(res?.data?.msg);
            setLoading(false)
  
          } else {
            
            setGodownLocations([])
          }
    
          }
  
      }) 
  
   }
  
   useEffect(()=>{


    if (selectedLocation) {
      const timeout = setTimeout(() => {
        setAnimationClass("popup-animation-enter-active"); // Trigger active state
      }, 0);

      return () => clearTimeout(timeout);
    }

    fetchMapdata_branch();
    fetchMapdata_wearhouse();

   },[selectedLocation])

  return (
    <div className="wrapper_sm branch_sec">
      <Tabs className='tabContent' defaultActiveKey="branch" onChange={handleTabChange}>
        <Tabs.TabPane tab="Branch Network" key="branch">
          <Map
            initialViewState={{
              longitude: 88.3629,
              latitude: 22.5744,
              zoom: 5,
            }}
            style={{ width: "100%", height: "400px" }}
            mapStyle="mapbox://styles/mapbox/streets-v11"
            mapboxAccessToken={MAPBOX_TOKEN}
          >

          {locations_Map.map((location_item, index) => (
            <>
              
            {location_item.location.includes(",") && (
            <Marker
                key={index}
                // longitude={location_item.coordinates[0]}
                // latitude={location_item.coordinates[1]}
                longitude={location_item.location.split(",").map(Number)[1]}
                latitude={location_item.location.split(",").map(Number)[0]}
                // anchor="bottom"
              >
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => handleMarkerClick(location_item)}
                >
                  <i class="fa fa-map-marker mapIcon_cus" aria-hidden="true"></i>

                </div>

              </Marker>
            )}
            </>
            ))}

            {selectedLocation && (
              <Popup
                longitude={selectedLocation.location.split(",").map(Number)[1]}
                latitude={selectedLocation.location.split(",").map(Number)[0]}
                onClose={() => setSelectedLocation(null)}
                closeOnClick={false}
                className={animationClass}
              >
                <div 
                  dangerouslySetInnerHTML={{ __html: '<strong>'+ selectedLocation?.branch_name + '</strong>' + '</br>' + selectedLocation?.addr}}
                />
                {selectedLocation?.location_link && (
                  <a
                href={`${selectedLocation?.location_link}`} // Replace with your actual route for branch details
                target="_blank" // Opens the link in a new tab
                rel="noopener noreferrer" // Adds security for new tab links
                className="mapPopup_link"// Style the link
                >
                View More
                </a>
                )}
                
              </Popup>
            )}
          </Map>
        </Tabs.TabPane>
        <Tabs.TabPane tab="Godown Network" key="godown">
          <Map
            initialViewState={{
              longitude: 88.3629,
              latitude: 22.5744,
              zoom: 5,
            }}
            style={{ width: "100%", height: "400px" }}
            mapStyle="mapbox://styles/mapbox/streets-v11"
            mapboxAccessToken={MAPBOX_TOKEN}
          >
            {locations_Map.map((location_item, index) => (
              <>
              
              {location_item.location.includes(",") && (
              <Marker
                key={index}
                longitude={location_item.location.split(",").map(Number)[1]}
                latitude={location_item.location.split(",").map(Number)[0]}
                anchor="bottom"
              >
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => handleMarkerClick(location_item)}
                >
                {/* {JSON.stringify(location_item.location.split(","), null, 2)}  */}
                <i class="fa fa-map-marker mapIcon_cus" aria-hidden="true"></i>

                </div>
              </Marker>
              )}
              </>
              ))}


            {selectedLocation && (
              <Popup
                // longitude={selectedLocation.coordinates[0]}
                // latitude={selectedLocation.coordinates[1]}
                longitude={selectedLocation.location.split(",").map(Number)[1]}
                latitude={selectedLocation.location.split(",").map(Number)[0]}
                onClose={() => setSelectedLocation(null)}
                closeOnClick={false}
                className={animationClass}
              >
                <div
                  dangerouslySetInnerHTML={{ __html: '<strong>'+ selectedLocation?.w_name + '</strong>' + '</br>' + selectedLocation?.w_addrs}}
                />

                {selectedLocation?.location_link && (
                  <a
                href={`${selectedLocation?.location_link}`} // Replace with your actual route for branch details
                target="_blank" // Opens the link in a new tab
                rel="noopener noreferrer" // Adds security for new tab links
                className="mapPopup_link"// Style the link
                >
                View More
                </a>
                )}
                
              </Popup>
            )}
          </Map>
        </Tabs.TabPane>
      </Tabs>
    </div>
  );
}

export default TabContentHome_NetworkMap;
